import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

const TopicPlaceholder = ({ amount = 1 }) => {
  return (
    <div role="alert" aria-label="alert" aria-busy="true">
      {[...Array(amount)].map((_, index) => (
        <div
          key={index}
          className="relative mb-3 last:mb-0 rounded-lg overflow-hidden shadow-card"
        >
          <div className="p-4 bg-white">
            <div className="mb-3">
              <Shimmer style={{ width: '100%' }} height={18} />
            </div>
            <div className="flex -mx-2 mb-4">
              <div className="flex items-center px-2">
                <Shimmer width={36} height={16} />
              </div>
              <div className="flex items-center px-2">
                <Shimmer width={36} height={16} />
              </div>
            </div>
            <div className="mb-4">
              <Shimmer style={{ width: '100%' }} height={16} />
            </div>
            <div className="flex flex-wrap items-center justify-between">
              <div className="w-[140px]">
                <Shimmer width={140} height={16} />
              </div>
              <div className="ml-auto">
                <Shimmer width={88} height={16} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default TopicPlaceholder
